import { forwardRef } from 'react'
import Map, { MapProps, MapRef, NavigationControl } from 'react-map-gl'
import { useCurrentUser } from '../../hooks/users'
import MapLayerControl, { MapOverlayOption } from './MapLayerControl'
import { climateLayersEnabled } from './catalogue'

export type ClimateMapProps = MapProps & {
  mapOverlays?: MapOverlayOption[]
  mapNavigation?: boolean
}

const ClimateMap = forwardRef<MapRef, ClimateMapProps>(
  ({ children, mapOverlays = [], mapNavigation = false, ...props }, ref) => {
    const { data: user } = useCurrentUser()
    const enabled = climateLayersEnabled(user)
    return (
      <Map {...props} ref={ref}>
        {children}
        {mapNavigation && <NavigationControl position="top-right" />}
        <MapLayerControl
          key={user?.organisation?.id ?? 'loading'}
          climateEnabled={enabled}
          overlays={mapOverlays}
          hasNavigationControl={mapNavigation}
        />
      </Map>
    )
  },
)

ClimateMap.displayName = 'ClimateMap'
export default ClimateMap
